/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.24/esri/copyright.txt for details.
*/
class t{constructor(t,o,i,s){this.coordinateHelper=t,this.targetPoint=o,this.constraint=i,this.elevationInfo=s}}export{t as SnappingCandidate};
